<template>
  <div class="nav-header">
    <div class="header-container">
      <div class="header-main">
        <div class="container">
          <!-- Logo区域 - 只显示图片 -->
          <div class="logo-section" @click="$router.push('/')">
            <img src="/imgs/logo.png" style="height: 90px;" class="logo-image">
          </div>

          <!-- 主导航 -->
          <div class="main-navigation">
            <nav class="nav-menu">
              <a href="/" class="nav-item">
                <span class="nav-icon">🏠</span>
                <span class="nav-text">网站首页</span>
              </a>
              <a href="/#/ac1" class="nav-item">
                <span class="nav-icon">📰</span>
                <span class="nav-text">行业资讯</span>
              </a>
              <a href="/#/info" class="nav-item">
                <span class="nav-icon">👥</span>
                <span class="nav-text">关于我们</span>
              </a>
              <a href="/#/xy" class="nav-item">
                <span class="nav-icon">📝</span>
                <span class="nav-text">用户协议</span>
              </a>
            </nav>
          </div>

          <!-- 用户功能区 -->
          <div class="user-section" >
            <!-- 搜索框 -->
            <div class="search-container" style="display: none;">
              <el-input
                v-model="searchKey"
                placeholder="搜索旅游资讯..."
                @keyup.enter.native="handleSearch"
                clearable
                ref="searchInput"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="handleSearch"
                ></el-button>
              </el-input>
            </div>

            <!-- 用户状态 -->
            <div class="user-auth">
              <div class="auth-btn" @click="goLogin()" v-show="this.LoggedShow">
                <span class="auth-icon">🔐</span>
                <span class="auth-text">登录 / 注册</span>
              </div>
              <div class="user-profile" v-show="!this.LoggedShow">
                <div class="user-welcome">
                  <span class="welcome-icon">👋</span>
                  <span class="user-name" v-text="this.nv_user.Username"></span>
                </div>
                <div class="logout-btn" @click="tolg()">
                  <span class="logout-icon">🚪</span>
                  <span class="logout-text">退出</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-header",
  props: {
    href: String,
  },
  data() {
    return {
      isFixed: false,
      LoggedShow: true,
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      state: JSON.parse(window.localStorage.getItem("state")),
      // 搜索关键词（默认从当前路由参数获取）
      searchKey: this.$route.query.keyword || '',
    };
  },
  watch: {
    // 监听路由变化，确保搜索框状态与路由同步
    '$route'(to) {
      // 当路由变化时，更新搜索框的关键词
      this.searchKey = to.query.keyword || '';
      
      // 如果当前在搜索页，清空搜索框并聚焦
      if (to.name === 'Sr' && !to.query.keyword) {
        this.searchKey = '';
        this.$nextTick(() => {
          this.$refs.searchInput.focus();
        });
      }
    }
  },
  mounted() {
    this.logged();
    window.addEventListener("scroll", this.initHeight);
  },
  methods: {
    initHeight() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      this.isFixed = scrollTop > 80 ? true : false;
    },
    logged() {
      if (this.state == "0") {
        this.LoggedShow = false;
      }
    },
    goLogin() {
      this.$router.push("/login");
    },
    goRegister() {
      this.$router.push("/register");
    },
    tolg() {
      if (this.k) {
        window.localStorage.setItem("state", "10");
        window.localStorage.removeItem("k");
        this.$router.push("/");
        location.reload();
      } else {
        window.localStorage.setItem("state", "10");
        this.$router.push("/");
        location.reload();
      }
    },
    goAc() {
      this.$router.push("/ac");
    },
    goInfo() {
      this.$router.push("/info");
    },
    
    // 搜索方法：统一处理所有页面的搜索请求
    handleSearch() {
      const keyword = this.searchKey.trim();
      
      if (keyword) {
        // 判断当前是否已经在搜索页
        if (this.$route.name === 'Sr') {
          // 在搜索页内搜索时，更新路由参数
          this.$router.replace({
            path: '/search',
            query: { keyword: keyword }
          });
        } else {
          // 从其他页面跳转到搜索页
          this.$router.push({
            path: '/search',
            query: { keyword: keyword }
          });
        }
        
        // 清空搜索框内容
        this.searchKey = '';
      } else {
        this.$message.warning('请输入搜索关键词');
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.initHeight, false);
  },
};
</script>

<style lang="scss" scoped>
// 使用方案2的颜色变量
$primary-color: #d4b896;
$primary-dark: #bfa07d;
$primary-light: #e9d4b8;
$accent-color: #5a8fb4;
$text-dark: #2c3e50;
$text-light: #7f8c8d;
$background: #f9f7f2;
$card-bg: #ffffff;

.nav-header {
  width: 100%;
  background: $card-bg;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1000;
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
  border-bottom: 1px solid rgba(212, 184, 150, 0.2);

  .header-container {
    .header-main {
      .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 85px;

        // Logo区域 - 只显示图片
        .logo-section {
          flex: 0 0 auto;
          cursor: pointer;
          transition: all 0.3s ease;
          padding: 5px;
          border-radius: 12px;

          &:hover {
            transform: translateY(-3px);
            background: rgba(212, 184, 150, 0.05);
          }

          .logo-image {
            height: 55px;
            width: auto;
            object-fit: contain;
            filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.15));
          }
        }

        // 主导航
        .main-navigation {
          flex: 1;
          display: flex;
          justify-content: center;
          margin: 0 40px;

          .nav-menu {
            display: flex;
            align-items: center;
            gap: 5px;
            background: linear-gradient(135deg, rgba(212, 184, 150, 0.05) 0%, rgba(90, 143, 180, 0.05) 100%);
            border-radius: 35px;
            padding: 6px;
            box-shadow: 
              inset 0 1px 3px rgba(255, 255, 255, 0.8),
              0 4px 15px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(212, 184, 150, 0.2);

            .nav-item {
              display: flex;
              align-items: center;
              gap: 8px;
              padding: 12px 24px;
              border-radius: 30px;
              text-decoration: none;
              color: $text-dark;
              font-weight: 600;
              font-size: 15px;
              transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
              position: relative;
              overflow: hidden;

              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
                transition: left 0.6s;
              }

              .nav-icon {
                font-size: 18px;
                transition: all 0.3s ease;
              }

              &:hover {
                background: linear-gradient(135deg, $primary-color, $primary-dark);
                color: white;
                transform: translateY(-2px);
                box-shadow: 0 6px 20px rgba(212, 184, 150, 0.4);

                .nav-icon {
                  transform: scale(1.2) rotate(5deg);
                }

                &::before {
                  left: 100%;
                }
              }

              &.active {
                background: linear-gradient(135deg, $primary-dark, $primary-color);
                color: white;
                box-shadow: 0 4px 15px rgba(212, 184, 150, 0.4);

                &::after {
                  content: '';
                  position: absolute;
                  bottom: -10px;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 8px;
                  height: 8px;
                  background: $primary-color;
                  border-radius: 50%;
                  box-shadow: 0 0 10px $primary-color;
                }
              }
            }
          }
        }

        // 用户功能区
        .user-section {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          gap: 25px;

          // 搜索框
          .search-container {
            .el-input {
              border-radius: 25px;
              overflow: hidden;
              box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);

              ::v-deep .el-input__inner {
                border: none;
                padding: 0 20px;
                height: 42px;
                line-height: 42px;
                background-color: #f8f9fa;
                font-size: 14px;
                transition: all 0.3s ease;

                &:focus {
                  background-color: $card-bg;
                  box-shadow: 0 0 0 2px rgba(212, 184, 150, 0.3);
                }
              }

              ::v-deep .el-input-group__append {
                background: linear-gradient(135deg, $primary-color, $primary-dark);
                border: none;
                color: white;
                padding: 0 20px;
                cursor: pointer;
                transition: all 0.3s ease;
                font-weight: 600;

                &:hover {
                  background: linear-gradient(135deg, $primary-dark, $primary-color);
                  transform: translateX(2px);
                }
              }
            }
          }

          // 用户认证区域
          .user-auth {
            .auth-btn {
              display: flex;
              align-items: center;
              gap: 10px;
              padding: 12px 24px;
              background: linear-gradient(135deg, $primary-color, $primary-dark);
              color: white;
              border-radius: 30px;
              cursor: pointer;
              transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
              font-weight: 600;
              box-shadow: 0 4px 15px rgba(212, 184, 150, 0.3);
              position: relative;
              overflow: hidden;

              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                transition: left 0.6s;
              }

              &:hover {
                transform: translateY(-3px);
                box-shadow: 0 8px 25px rgba(212, 184, 150, 0.5);
                background: linear-gradient(135deg, $primary-dark, $primary-color);

                &::before {
                  left: 100%;
                }
              }

              .auth-icon {
                font-size: 18px;
                transition: transform 0.3s ease;
              }

              &:hover .auth-icon {
                transform: scale(1.2);
              }
            }

            .user-profile {
              display: flex;
              align-items: center;
              gap: 15px;

              .user-welcome {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 10px 18px;
                background: linear-gradient(135deg, rgba(212, 184, 150, 0.1), rgba(90, 143, 180, 0.05));
                border-radius: 25px;
                border: 1px solid rgba(212, 184, 150, 0.2);

                .welcome-icon {
                  font-size: 18px;
                }

                .user-name {
                  font-size: 15px;
                  color: $text-dark;
                  font-weight: 600;
                }
              }

              .logout-btn {
                display: flex;
                align-items: center;
                gap: 6px;
                padding: 8px 16px;
                background: rgba(0, 0, 0, 0.05);
                border-radius: 20px;
                cursor: pointer;
                transition: all 0.3s ease;
                font-size: 14px;
                color: $text-light;
                border: 1px solid rgba(0, 0, 0, 0.1);

                &:hover {
                  background: rgba(0, 0, 0, 0.1);
                  color: $text-dark;
                  transform: translateY(-1px);
                }

                .logout-icon {
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 响应式调整
@media (max-width: 1024px) {
  .nav-header .header-main .container {
    padding: 0 20px;
    
    .main-navigation {
      margin: 0 20px;
      
      .nav-menu {
        gap: 3px;
        
        .nav-item {
          padding: 10px 18px;
          font-size: 14px;
          
          .nav-icon {
            font-size: 16px;
          }
        }
      }
    }
    
    .user-section {
      gap: 15px;
      
      .user-auth {
        .auth-btn {
          padding: 10px 18px;
          font-size: 14px;
        }
        
        .user-profile {
          gap: 10px;
          
          .user-welcome {
            padding: 8px 14px;
            
            .user-name {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .nav-header .header-main .container {
    padding: 0 15px;
    height: 70px;
    
    .logo-section .logo-image {
      height: 45px;
    }
    
    .main-navigation {
      margin: 0 10px;
      
      .nav-menu {
        .nav-item {
          padding: 8px 12px;
          font-size: 13px;
          
          .nav-text {
            display: none;
          }
          
          .nav-icon {
            font-size: 16px;
            margin: 0;
          }
        }
      }
    }
    
    .user-section {
      .user-auth {
        .auth-btn {
          padding: 8px 12px;
          
          .auth-text {
            display: none;
          }
        }
        
        .user-profile {
          .user-welcome .user-name {
            display: none;
          }
        }
      }
    }
  }
}
</style>